import { render, staticRenderFns } from "./AccountDisabled.vue?vue&type=template&id=74e2fd2a"
import script from "./AccountDisabled.vue?vue&type=script&lang=js"
export * from "./AccountDisabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports